import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/app/App'

import '@phosphor-icons/web/regular'
import '@/styles/index.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Elemento #root não encontrado no index.html')
}

/**
 * Start MSW before the first render — story 0.6 AC-10.
 *
 * 🔒 **`api/mocks/iniciar` is stubbed to a no-op in a production build** by a Vite
 * plugin, so the MSW graph has no live reference and Rollup emits none of it. The
 * dynamic import and the `DEV` guard are still here, but they are the belt: the
 * plugin is the braces, and it is the one that actually holds — relying on
 * tree-shaking alone left 160 kB gzip of MSW in `dist/`.
 *
 * Whether MSW runs is a **build fact**, not an environment fact — which is why it
 * is a `VITE_*` variable and not a `config.json` key. `config.json` holds values
 * that differ per environment for the SAME artifact; MSW must not be in the
 * artifact at all.
 *
 * ⚠️ **AC-10 says this touches no screen, and it does not.** No component knows
 * whether it is talking to MSW or to a gateway; the only thing that changes is
 * which host `config.json` resolves to.
 */
async function iniciarMocks(): Promise<void> {
  if (!import.meta.env.DEV) return
  const { iniciarMocksNoNavegador } = await import('@/api/mocks/iniciar')
  await iniciarMocksNoNavegador()
}

void iniciarMocks().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
